import { Grid, Paper, Button } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import useReactHookForm from "hooks/useReactHookForm";
import ContentRight from "shared/molecules/content-right";
import { useEffect } from "react";
import { hasAtLeastOneValue, employeeDeptInitialValues, employeeDeptProperties, employeeDeptValidationSchema } from "./helper";

export function EmployeeDepartmentsFilter({ setSearchPayload, setPage, clearValuesTrigger }) {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    employeeDeptInitialValues,
    employeeDeptValidationSchema,
    "",
  );

  const handleSearch = () => {
    const payload: any = {};
    const values = watch();

    if (values.searchName) payload.searchName = values.searchName;

    if (values.isTeaching === "true") payload.isTeaching = true;
    else if (values.isTeaching === "false") payload.isTeaching = false;
    
    if (values.isLanguage === "true") payload.isLanguage = true;
    else if (values.isLanguage === "false") payload.isLanguage = false;
    
    setSearchPayload(payload);
    setPage(1);
  }

  const clearFilter = () => {
    setValue("searchName", "");
    setValue("isTeaching", "");
    setValue("isLanguage", "");
    setSearchPayload({});
    setPage(1);
  }

  useEffect(() => {
    clearFilter()
  }, [clearValuesTrigger])

  return (
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 3, pt: 3 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={employeeDeptProperties}
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
          />

          <ContentRight sx={{ mt: -7 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!hasAtLeastOneValue(watch(), ["searchName", "isTeaching", "isLanguage"]) || Object.keys(errors).length > 0}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "15px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              disabled={!hasAtLeastOneValue(watch(), ["searchName", "isTeaching", "isLanguage"]) || Object.keys(errors).length > 0}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
}
